import React from 'react';
import { Create, SimpleForm, TextInput, ReferenceInput, NumberInput, SelectInput, required } from 'react-admin';
import { coreWalletInvoiceTypesForSelection } from './InvoiceConstants';
import PropTypes from 'prop-types';

const vatDefinitionRenderer = choice => `${choice.id}: ${choice.description}`;

const InvoiceCreate = ({
	invoiceTypesForSelection,
	...props
}) => (
	<Create {...props}>
		<SimpleForm variant="standard">
			<TextInput source="walletAccountId" resettable validate={required()} />
			<NumberInput source="invoiceAmount" resettable validate={required()} />
			<TextInput source="invoiceCurrency" resettable validate={required()} />
			<ReferenceInput source="systemAccountId" reference="accountingAccounts" validate={required()}>
				<TextInput resettable />
			</ReferenceInput>
			<ReferenceInput source="vatDefinitionId" reference="vatDefinitions" validate={required()}>
				<SelectInput optionText={vatDefinitionRenderer} resettable />
			</ReferenceInput>
			<TextInput source="description" resettable validate={required()} />
			<TextInput source="customType" resettable />
		</SimpleForm>
	</Create>
);

InvoiceCreate.propTypes = {
	invoiceTypesForSelection: PropTypes.array.isRequired
};
InvoiceCreate.defaultProps = {
	invoiceTypesForSelection: coreWalletInvoiceTypesForSelection
};

export default InvoiceCreate;
